export { VpFilterSelect } from './VpFilterSelect';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpFilterSelect/index.js